@if (teaser() !== '') {
  <p [innerHTML]="teaser()">
    {{ teaser() }}
  </p>
}
@if (teaserShort() !== '') {
  <p class="teaser-short">
    {{ teaserShort() }}
  </p>
}
@if (phonePrefix() !== '') {
  @if (customData()['contactInfo.phone']) {
    <p class="text--bold">{{ phonePrefix() }}{{ customData()['contactInfo.phone'] }}</p>
  } @else {
    <p class="text--bold">{{ phonePrefix() }}{{ organisation().contactInfo.phone }}</p>
  }
}
@if (subtitle() !== '') {
  <p class="text--bold" [innerHTML]="subtitle()">
    {{ subtitle() }}
  </p>
}
<p>
  {{ organisation().name }}<br />
  {{ organisation().address.street }} {{ organisation().address.streetNumber }}<br />
  {{ organisation().address.zipCode }} {{ organisation().address.city }}
</p>

@if (withContactForm()) {
  <ez-button
    class="block--centered"
    theme="primary"
    label="Kontaktformular öffnen"
    (buttonClick)="openContactForm()"
    maxWidth="300px"
  ></ez-button>
}
